import template from './home-button.html';
import Kiwi from '../kiwi/kiwi-service';

export default {
	name: 'HomeButton',
	template,
	created () {
		const {config, images} = this.$root;
		this.targetName = config.targetName;
		this.playPauseBtn = images.PlayButton;
	},
	data () {
		return {
			name: '',
			isPlaying: false,
			playPauseBtn: '',
			targetName: ''
		};
	},
	computed: {
		playingHighlighting () {
			if (this.isPlaying) {
				return 'playing-video';
			}
			return '';
		},
		buttonDisabled () {
			if (!this.isDisabled) {
				return '';
			}
			return 'button-disable';
		}
	},
	methods: {
		play () {
			this.$refs.videoRef.currentTime = 0;
			return this.$refs.videoRef.play();
		},
		pause () {
			const promise = this.$refs.videoRef.pause();
			this.$refs.videoRef.currentTime = 0;
			return promise;
		},
		forceVideoPlay () {
			if (this.isDisabled) {
				return;
			}
			if (this.isTv) {
				// switch to tv
				return;
			}
			this.$emit('on-video-play-force', this.id);
			Kiwi.playVideo(this.targetName, `${window.location.href}/fullscreen/${this.videoSource}`, 'text/html', (mediaReferenceId) => {
				// console.log(`kiwi mediaId ${mediaReferenceId}`);
			});
		},
		onEnd () {
			this.$emit('on-video-end', this.id);
			Kiwi.hideVideo('display2.euronics');
		}
	},
	props: ['text', 'posterImage', 'textIcon', 'videoSource', 'id', 'isDisabled', 'isTv']
};



// WEBPACK FOOTER //
// ./src/home-button/home-button.js